import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id in callback');
        navigate('/login');
        return;
      }

      try {
        await handleGoogleCallback(sessionId);
        // Check if user needs onboarding
        navigate('/discover');
      } catch (error) {
        console.error('Auth callback failed:', error);
        navigate('/login');
      }
    };

    processCallback();
  }, []);

  return (
    <div className="min-h-screen bg-dark flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-gold border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-400 font-body">Signing you in...</p>
      </div>
    </div>
  );
}
